import { defineStore } from 'pinia';
import type { ToastType, ToastState, ToastOptions } from './types';

// For usage inside this component only - use useToast to open toasts
export const useToastStore = defineStore('toasts', () => {
  const toasts = ref<ToastState[]>([]);

  function getOpenToastFn(type: ToastType) {
    return (text: string, options?: ToastOptions) => {
      toasts.value.push({
        type,
        text,
        openedAt: Date.now(),
        isOpen: true,
        options,
      });
    };
  }

  function remove(toast: ToastState) {
    toast.isOpen = false;

    // Clean up after animation is complete
    setTimeout(() => {
      const index = toasts.value.indexOf(toast);
      if (index !== -1) {
        toasts.value.splice(index, 1);
      }
    }, 5e3);
  }

  return {
    toasts,
    getOpenToastFn,
    remove,
  };
});

export function useToast() {
  const store = useToastStore();

  return {
    success: store.getOpenToastFn('success'),
    error: store.getOpenToastFn('error'),
    info: store.getOpenToastFn('info'),
    warning: store.getOpenToastFn('warning'),
  };
}
